"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8478],{

/***/ 73925:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ AllAirdropsGrid; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Loader/Loader.js + 3 modules
var Loader = __webpack_require__(76080);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Pagination/Pagination.js + 12 modules
var Pagination = __webpack_require__(37065);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/swiper/react/swiper-react.js + 14 modules
var swiper_react = __webpack_require__(88494);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.esm.js + 92 modules
var swiper_esm = __webpack_require__(89979);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/airdrop/hooks/useFetchData.ts
var useFetchData = __webpack_require__(82741);
// EXTERNAL MODULE: ./src/airdrop/utils/urlToHttp.ts
var urlToHttp = __webpack_require__(49556);
// EXTERNAL MODULE: ./src/chain-info/KaratDaoSupportedChain.ts
var KaratDaoSupportedChain = __webpack_require__(93171);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/airdrop/components/ImageProcessor.js
var ImageProcessor = __webpack_require__(97404);
// EXTERNAL MODULE: ./src/utils/format.ts
var format = __webpack_require__(6767);
;// CONCATENATED MODULE: ./src/airdrop/components/homepage/CarouselMobileItem.js










var CarouselMobileItem = function(param) {
    var campaign = param.campaign, feature = param.feature;
    var ref;
    var ref1 = (0,react.useState)(false), load = ref1[0], setLoad = ref1[1];
    var ref2 = (0,useFetchData/* default */.Z)(campaign === null || campaign === void 0 ? void 0 : campaign.baseInfo), // loading: baseInfoURILoading,
    // error: baseInfoURIError,
    baseInfoURIData = ref2.data;
    (0,react.useEffect)(function() {
        if (baseInfoURIData !== undefined && baseInfoURIData.image_preview === undefined) {
            var ref;
            baseInfoURIData.image_preview = (ref = (0,urlToHttp/* default */.Z)(baseInfoURIData === null || baseInfoURIData === void 0 ? void 0 : baseInfoURIData.image_hash)[0]) !== null && ref !== void 0 ? ref : //FIXME
            (0,urlToHttp/* default */.Z)(baseInfoURIData === null || baseInfoURIData === void 0 ? void 0 : baseInfoURIData.image)[0];
        }
    }, [
        baseInfoURIData
    ]);
    // console.log(campaign);
    // console.log(baseInfoURIData);
    var expectedChain = KaratDaoSupportedChain/* KARATDAO_DEFAULT_SUPPORTED_CHAINS.find */.f.find(function(network) {
        return network.chainId === (campaign === null || campaign === void 0 ? void 0 : campaign.chainId);
    });
    var chainName = expectedChain === null || expectedChain === void 0 ? void 0 : expectedChain.chainName;
    var chainNameEth = chainName === "Mainnet" ? "Ethereum" : chainName;
    // const icon = useMemo(() => {
    //   return chainName
    //     ? `https://defillama.com/chain-icons/${chainLogo}.jpg`
    //     : '/unknown-logo.png';
    // }, [chainName, chainLogo]);
    // eslint-disable-next-line
    var chainIcon = (0,format/* getChainIcon */.Sv)(chainNameEth);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: "/airdrops/".concat(chainName, "/").concat(campaign === null || campaign === void 0 ? void 0 : (ref = campaign.type) === null || ref === void 0 ? void 0 : ref.toLowerCase(), "/").concat(campaign === null || campaign === void 0 ? void 0 : campaign.airdropAddr),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: classnames_default()("flex w-full flex-col", feature ? "h-full justify-between rounded-sm bg-bgv" : "h-full justify-between rounded-sm bg-white"),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex h-64 w-full",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageProcessor/* default */.Z, {
                        src: baseInfoURIData === null || baseInfoURIData === void 0 ? void 0 : baseInfoURIData.image,
                        size: "s300",
                        className: "w-full rounded-sm object-cover object-center"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex h-28 w-full flex-col justify-between",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mx-3 mt-3 flex",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: feature ? "overflow-hidden text-ellipsis text-lg font-bold text-primary" : "overflow-hidden text-ellipsis text-lg font-bold text-black",
                                children: (campaign === null || campaign === void 0 ? void 0 : campaign.name.length) <= 60 ? campaign === null || campaign === void 0 ? void 0 : campaign.name : (campaign === null || campaign === void 0 ? void 0 : campaign.name.substring(0, 60)) + "..."
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: feature ? "mx-3 flex flex-row justify-between pb-5 text-xs text-gray" : "mx-3 flex flex-row justify-between pb-5 text-xs text-black",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: "Max Supply"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: (campaign === null || campaign === void 0 ? void 0 : campaign.type) === "TOKEN" ? campaign === null || campaign === void 0 ? void 0 : campaign.reach : campaign === null || campaign === void 0 ? void 0 : campaign.maxSupply
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
;// CONCATENATED MODULE: ./src/airdrop/components/Doodle.tsx
// @ts-nocheck





function Doodle(_param) {
    var _rule = _param.rule, rule = _rule === void 0 ? "" : _rule, _seed = _param.seed, seed = _seed === void 0 ? "" : _seed, props = (0,_object_without_properties/* default */.Z)(_param, [
        "rule",
        "seed"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("css-doodle", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        seed: seed
    }, props), {
        children: rule
    }));
}

;// CONCATENATED MODULE: ./src/airdrop/components/homepage/CarouselFormItemMobile.js











var CarouselFormItem = function(param) {
    var campaign = param.campaign, feature = param.feature;
    var ref, ref1;
    var name = (ref = campaign.form.blocks.find(function(block) {
        return block.id === "title";
    })) === null || ref === void 0 ? void 0 : ref.title;
    var reward = (ref1 = campaign.form.blocks.find(function(block) {
        return block.id === "reward";
    })) === null || ref1 === void 0 ? void 0 : ref1.type;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: "/forms/".concat(campaign.id),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: classnames_default()("flex w-full flex-col", feature ? "h-full justify-between rounded-sm bg-bgv" : "h-full justify-between rounded-sm bg-white"),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex h-64 w-full overflow-hidden",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Doodle, {
                        seed: name,
                        rule: "\n            @grid: @p(3,4,5) / 87vmin;\n:container {\n  gap: 4px;\n}\ntransform: rotate(@p(0, 90, 180, 270)deg);\nbackground-image: @doodle(\n  @grid: @p(1, 2, 3) / 100%;\n  :container {\n    gap: 4px;\n  }\n  transform: rotate(@p(0, 90, 180, 270)deg);\n  background:\n    @m(@r4, (radial-gradient(circle at @pn(0, 100, 100, 0)% @pn(0, 100, 0, 100)%, @p(#689FC0, #CF6756, #543235, #F6C7C8, #ECBB3F, #4B639D, #5A8863, #DE7970, #FDF9CC) calc(35.36% - 2px), #000 calc(35.36% - 1.5px), #000 calc(35.36% + 2px), transparent calc(35.36% + 2.5px)))),\n    linear-gradient(@p(#689FC0, #CF6756, #543235, #F6C7C8, #ECBB3F, #4B639D, #5A8863, #DE7970, #FDF9CC), @lp);\n  @random(0.2) {\n    background:\n      linear-gradient(@p(#689FC0, #CF6756, #543235, #F6C7C8, #ECBB3F, #4B639D, #5A8863, #DE7970, #FDF9CC) calc(50% - 2px), #000 calc(50% - 1.5px), #000 calc(50% + 2px), @p(#689FC0, #CF6756, #543235, #F6C7C8, #ECBB3F, #4B639D, #5A8863, #DE7970, #FDF9CC) calc(50% + 2.5px));\n  }\n  @random(0.2) {\n    background:\n      @m(@r2, (radial-gradient(circle at @pn(0, 100)% 50%, @p(#689FC0, #CF6756, #543235, #F6C7C8, #ECBB3F, #4B639D, #5A8863, #DE7970, #FDF9CC) calc(44.3% - 2px), #000 calc(44.3% - 1.5px), #000 calc(44.3% + 2px), transparent calc(44.3% + 2.5px)))),\n      linear-gradient(@p(#689FC0, #CF6756, #543235, #F6C7C8, #ECBB3F, #4B639D, #5A8863, #DE7970, #FDF9CC), @lp);\n  }\n  @random(0.2) {\n    background:\n      radial-gradient(circle at 0 50%, @p(#689FC0, #CF6756, #543235, #F6C7C8, #ECBB3F, #4B639D, #5A8863, #DE7970, #FDF9CC) calc(44.3% - 2px), #000 calc(44.3% - 1.5px), #000 calc(44.3% + 2px), transparent calc(44.3% + 2.5px)),\n      radial-gradient(circle at 100% @p(0, 100%), @p(#689FC0, #CF6756, #543235, #F6C7C8, #ECBB3F, #4B639D, #5A8863, #DE7970, #FDF9CC) calc(35.36% - 2px), #000 calc(35.36% - 1.5px), #000 calc(35.36% + 2px), transparent calc(35.36% + 2.5px)),\n      linear-gradient(@p(#689FC0, #CF6756, #543235, #F6C7C8, #ECBB3F, #4B639D, #5A8863, #DE7970, #FDF9CC), @lp);\n  }\n  @random(0.2) {\n    --color: @p(#689FC0, #CF6756, #543235, #F6C7C8, #ECBB3F, #4B639D, #5A8863, #DE7970, #FDF9CC);\n    background:\n      @m(2, (linear-gradient(@pn(180, 90)deg, @pn(transparent, var(--color)) calc(100% - 4px), #000 calc(100% - 4px)) no-repeat 0 0 / calc(50% + 2px) calc(50% + 2px))),\n      @p(radial-gradient(circle at 0 0, @p(#689FC0, #CF6756, #543235, #F6C7C8, #ECBB3F, #4B639D, #5A8863, #DE7970, #FDF9CC) calc(35.36% - 2px), #000 calc(35.36% - 1.5px), #000 calc(35.36% + 2px), transparent calc(35.36% + 2.5px)), linear-gradient(@m2(transparent))),\n      linear-gradient(@p(#689FC0, #CF6756, #543235, #F6C7C8, #ECBB3F, #4B639D, #5A8863, #DE7970, #FDF9CC), @lp);\n  }\n);\n              "
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex h-28 w-full flex-col justify-between",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mx-3 mt-3 flex",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: feature ? "overflow-hidden text-ellipsis text-lg font-bold text-primary" : "overflow-hidden text-ellipsis text-lg font-bold text-black",
                                children: name.length <= 60 ? name : name.substring(0, 60) + "..."
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: feature ? "mx-3 flex flex-row justify-between pb-5 text-xs text-gray" : "mx-3 flex flex-row justify-between pb-5 text-xs text-black",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: "Views"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: campaign.pageView
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Button/Button.js + 3 modules
var Button = __webpack_require__(67841);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.min.css
var swiper_min = __webpack_require__(30933);
// EXTERNAL MODULE: ./node_modules/swiper/modules/effect-cards/effect-cards.min.css
var effect_cards_min = __webpack_require__(74650);
// EXTERNAL MODULE: ./node_modules/swiper/modules/lazy/lazy.min.css
var lazy_min = __webpack_require__(38056);
;// CONCATENATED MODULE: ./src/airdrop/components/homepage/CampaignsCarouselMobile.js
// Direct React component imports



// import CampaignsCarouselMobile







var CampaignsCarouselMobile = function(param) {
    var recentCampaigns = param.recentCampaigns, campaignLoading = param.campaignLoading, feature = param.feature;
    var mostRecentCampaigns = recentCampaigns.slice(0, 5);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "my-10 flex flex-col ",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                effect: "cards",
                loop: true,
                // slidesPerView='auto'
                // maxBackfaceHiddenSlides={0}
                loopedSlides: 5,
                loopAdditionalSlides: 5,
                speed: 1000,
                // lazy={true}
                autoplay: {
                    delay: 2500,
                    disableOnInteraction: false,
                    pauseOnMouseEnter: true
                },
                modules: [
                    swiper_esm/* EffectCards */.c4,
                    swiper_esm/* Autoplay */.pt
                ],
                className: "h-96 w-60 md:w-64",
                children: mostRecentCampaigns.map(function(camp, slideIndex) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                        className: "flex items-center justify-center rounded-sm",
                        children: campaignLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: "Loading"
                        }) : camp.type === "FORM" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CarouselFormItem, {
                            campaign: camp,
                            feature: feature
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(CarouselMobileItem, {
                            campaign: camp,
                            feature: feature
                        })
                    }, slideIndex);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: feature ? "hidden w-full justify-center" : "flex w-full justify-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: "/airdrops?type=ALL&page=1",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                        className: "btn-sec mt-14 w-48 bg-accent text-black hover:bg-accent hover:bg-opacity-20",
                        children: "Explore More Campaigns"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var homepage_CampaignsCarouselMobile = (CampaignsCarouselMobile);

// EXTERNAL MODULE: ./src/chain-info/contracts/AirdropFactory.json
var contracts_AirdropFactory = __webpack_require__(65637);
// EXTERNAL MODULE: ./src/chain-info/contracts/NFTAirdropFactory.json
var contracts_NFTAirdropFactory = __webpack_require__(4651);
// EXTERNAL MODULE: ./src/chain-info/map.json
var map = __webpack_require__(14765);
;// CONCATENATED MODULE: ./src/airdrop/hooks/useAllCampaignsByType.ts







var useAllCampaignsByType_useAllCampaignsByType = function(campaignType, chainId) {
    var ref = useState(false), loading = ref[0], setLoading = ref[1];
    var ref1 = useState(), error = ref1[0], setError = ref1[1];
    var ref2 = useState([]), campaigns = ref2[0], setCampaigns = ref2[1];
    var TokenAbi = AirdropFactory.abi;
    var stringChainId = String(chainId);
    var airdropFactoryAddress = chainId ? networkMapping[stringChainId]["AirdropFactory"][0] : constants.AddressZero;
    var airdropFactoryInterface = new utils.Interface(TokenAbi);
    var airdropFactoryContract = new Contract(airdropFactoryAddress, airdropFactoryInterface);
    var NFTAbi = NFTAirdropFactory.abi;
    var nftAirdropFactoryAddress = chainId ? networkMapping[stringChainId]["NFTAirdropFactory"][0] : constants.AddressZero;
    var nftAirdropFactoryInterface = new utils.Interface(NFTAbi);
    var nftAirdropFactoryContract = new Contract(nftAirdropFactoryAddress, nftAirdropFactoryInterface);
    var contract = campaignType === "TOKEN" ? airdropFactoryContract : nftAirdropFactoryContract;
    var ref3;
    var ref4 = (ref3 = useCall({
        contract: contract,
        method: "getAllCampaigns",
        args: []
    }, {
        chainId: chainId
    })) !== null && ref3 !== void 0 ? ref3 : {}, value = ref4.value, callError = ref4.error;
    if (callError) {
        console.error(callError.message);
    }
    useEffect(function() {
        setLoading(true);
        if (value) {
            setCampaigns(value === null || value === void 0 ? void 0 : value[0]);
            setLoading(false);
        }
        if (callError) {
            setError(callError.message);
            setLoading(false);
        }
    }, [
        callError,
        value
    ]);
    return {
        campaigns: campaigns,
        error: error,
        loading: loading
    };
};
/* harmony default export */ var hooks_useAllCampaignsByType = ((/* unused pure expression or super */ null && (useAllCampaignsByType_useAllCampaignsByType)));

// EXTERNAL MODULE: ./src/airdrop/hooks/useCampaignInfo.ts
var hooks_useCampaignInfo = __webpack_require__(87655);
;// CONCATENATED MODULE: ./src/airdrop/hooks/useAllCampaigns.ts



var useAllCampaigns = function(chainId) {
    var ref = useAllCampaignsByType("TOKEN", chainId), tokenCampaigns = ref.campaigns, //error: campaignError,
    tokenCampaignLoading = ref.loading;
    var ref1 = useAllCampaignsByType("NFT", chainId), nftCampaigns = ref1.campaigns, //error: campaignError,
    nftCampaignLoading = ref1.loading;
    // const campaignsAddr = [...nftCampaigns, ...tokenCampaigns];
    var ref2 = useCampaignInfo("TOKEN", tokenCampaigns, chainId), tokenCampaignInfo = ref2.campaignInfo, tokenInfoLoading = ref2.loading;
    var ref3 = useCampaignInfo("NFT", nftCampaigns, chainId), nftCampaignInfo = ref3.campaignInfo, nftInfoLoading = ref3.loading;
    var loading = nftCampaignLoading || tokenCampaignLoading || tokenInfoLoading || nftInfoLoading;
    var campaigns = _to_consumable_array(nftCampaignInfo).concat(_to_consumable_array(tokenCampaignInfo));
    return [
        campaigns,
        loading
    ];
};
/* harmony default export */ var hooks_useAllCampaigns = ((/* unused pure expression or super */ null && (useAllCampaigns)));

;// CONCATENATED MODULE: ./src/airdrop/components/AirdropGridItem.js







var AirdropGridItem = function(param) {
    var campaign = param.campaign, feature = param.feature;
    var ref, ref1, ref2;
    var ref3 = (0,useFetchData/* default */.Z)(campaign === null || campaign === void 0 ? void 0 : campaign.baseInfo), // loading: baseInfoURILoading,
    // error: baseInfoURIError,
    baseInfoURIData = ref3.data;
    var expectedChain = KaratDaoSupportedChain/* KARATDAO_DEFAULT_SUPPORTED_CHAINS.find */.f.find(function(network) {
        return network.chainId === (campaign === null || campaign === void 0 ? void 0 : campaign.chainId);
    });
    var chainName = expectedChain === null || expectedChain === void 0 ? void 0 : expectedChain.chainName;
    var chainNameEth = chainName === "Mainnet" ? "Ethereum" : chainName;
    // const icon = useMemo(() => {
    //   return chainName
    //     ? `https://defillama.com/chain-icons/${chainLogo}.jpg`
    //     : '/unknown-logo.png';
    // }, [chainName, chainLogo]);
    var chainIcon = (0,format/* getChainIcon */.Sv)(chainNameEth);
    var dynamic_fit = (campaign === null || campaign === void 0 ? void 0 : (ref = campaign.name) === null || ref === void 0 ? void 0 : ref.includes("StepG&Karat")) ? "object-contain" : "object-cover";
    if ((campaign === null || campaign === void 0 ? void 0 : campaign.airdropAddr) === "0xcaaac618b5dec930c4c7c00d011a91196b112427" && (campaign === null || campaign === void 0 ? void 0 : campaign.name) === "Hay twitter airdrop campaign for eligible winners") {
        campaign.name = "HAY twitter airdrop campaign for eligible winners";
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: "/airdrops/".concat(chainName, "/").concat(campaign === null || campaign === void 0 ? void 0 : (ref1 = campaign.type) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase(), "/").concat(campaign === null || campaign === void 0 ? void 0 : campaign.airdropAddr),
        passHref: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
            className: " flex flex-col justify-between rounded-sm bg-white text-dark1",
            style: {
                filter: "drop-shadow(15px 4px 40px rgba(0, 0, 0, 0.1))"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: feature ? "flex flex-col justify-between" : "flex flex-col justify-between",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "relative",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "absolute left-[6px] top-[6px] rounded-full flex items-center justify-center",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        alt: "chainIcon",
                                        src: chainIcon,
                                        className: "h-5 w-5"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageProcessor/* default */.Z, {
                                    src: baseInfoURIData === null || baseInfoURIData === void 0 ? void 0 : baseInfoURIData.image,
                                    size: "s300",
                                    className: feature ? " h-[235px] w-full rounded-t-md ".concat(dynamic_fit, " bg-black object-center ") : " h-24 w-full rounded-t-md ".concat(dynamic_fit, " object-center ")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            id: "card-content",
                            className: feature ? " py-2 h-20 rounded-b-md px-2 font-bold text-dark1 bg-[#292939]/70" : " my-2 rounded-md px-2  text-dark1",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex h-full flex-col justify-between",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex flex-col",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "font-bold  text-sm  line-clamp-2 ".concat(feature ? "text-white" : "text-dark1"),
                                                children: campaign === null || campaign === void 0 ? void 0 : campaign.name
                                            }),
                                            !feature && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: " mb-1 flex flex-row justify-between",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "text-xs text-[#B3B8B8] opacity-50",
                                                    children: chainNameEth
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex flex-col",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: " flex flex-row justify-between",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "text-sm text-dark1 opacity-50",
                                                        style: {
                                                            display: feature ? "none" : ""
                                                        },
                                                        children: "Total"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "text-sm text-dark1 opacity-50",
                                                        style: {
                                                            display: feature ? "none" : ""
                                                        },
                                                        children: "Claimable"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: feature ? " flex flex-row text-white text-xs" : "flex flex-row justify-between text-dark1 text-xs",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        style: {
                                                            display: feature ? "" : "none"
                                                        },
                                                        children: "Supply:\xa0"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        children: campaign === null || campaign === void 0 ? void 0 : (ref2 = campaign.reach) === null || ref2 === void 0 ? void 0 : ref2.toString()
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        style: {
                                                            display: feature ? "none" : ""
                                                        },
                                                        children: [
                                                            (campaign === null || campaign === void 0 ? void 0 : campaign.type) === "NFT" ? "NFT" : "TOKEN",
                                                            " "
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "text-secondary flex items-center justify-center rounded-b-md bg-primary text-white py-1",
                    style: {
                        display: feature ? "none" : ""
                    },
                    children: "Claim"
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/airdrop/components/CampaignGridItem.tsx



var CampaignGridItem = function(param) {
    var campaign = param.campaign, _feature = param.feature, feature = _feature === void 0 ? false : _feature;
    var ref, ref1;
    var name = (ref = campaign.form.blocks.find(function(block) {
        return block.id === "title";
    })) === null || ref === void 0 ? void 0 : ref.title;
    var reward = (ref1 = campaign.form.blocks.find(function(block) {
        return block.id === "reward";
    })) === null || ref1 === void 0 ? void 0 : ref1.type;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: "/forms/".concat(campaign.id),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: " flex flex-col justify-between rounded-sm bg-bgv text-dark1 cursor-pointer",
            style: {
                filter: "drop-shadow(15px 4px 40px rgba(0, 0, 0, 0.1))"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-col justify-between",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "relative overflow-hidden ".concat(feature ? "h-[235px]" : "h-[96px]"),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Doodle, {
                                seed: name,
                                rule: "\n            @grid: @p(3,4,5) / 87vmin;\n:container {\n  gap: 4px;\n}\ntransform: rotate(@p(0, 90, 180, 270)deg);\nbackground-image: @doodle(\n  @grid: @p(1, 2, 3) / 100%;\n  :container {\n    gap: 4px;\n  }\n  transform: rotate(@p(0, 90, 180, 270)deg);\n  background:\n    @m(@r4, (radial-gradient(circle at @pn(0, 100, 100, 0)% @pn(0, 100, 0, 100)%, @p(#689FC0, #CF6756, #543235, #F6C7C8, #ECBB3F, #4B639D, #5A8863, #DE7970, #FDF9CC) calc(35.36% - 2px), #000 calc(35.36% - 1.5px), #000 calc(35.36% + 2px), transparent calc(35.36% + 2.5px)))),\n    linear-gradient(@p(#689FC0, #CF6756, #543235, #F6C7C8, #ECBB3F, #4B639D, #5A8863, #DE7970, #FDF9CC), @lp);\n  @random(0.2) {\n    background:\n      linear-gradient(@p(#689FC0, #CF6756, #543235, #F6C7C8, #ECBB3F, #4B639D, #5A8863, #DE7970, #FDF9CC) calc(50% - 2px), #000 calc(50% - 1.5px), #000 calc(50% + 2px), @p(#689FC0, #CF6756, #543235, #F6C7C8, #ECBB3F, #4B639D, #5A8863, #DE7970, #FDF9CC) calc(50% + 2.5px));\n  }\n  @random(0.2) {\n    background:\n      @m(@r2, (radial-gradient(circle at @pn(0, 100)% 50%, @p(#689FC0, #CF6756, #543235, #F6C7C8, #ECBB3F, #4B639D, #5A8863, #DE7970, #FDF9CC) calc(44.3% - 2px), #000 calc(44.3% - 1.5px), #000 calc(44.3% + 2px), transparent calc(44.3% + 2.5px)))),\n      linear-gradient(@p(#689FC0, #CF6756, #543235, #F6C7C8, #ECBB3F, #4B639D, #5A8863, #DE7970, #FDF9CC), @lp);\n  }\n  @random(0.2) {\n    background:\n      radial-gradient(circle at 0 50%, @p(#689FC0, #CF6756, #543235, #F6C7C8, #ECBB3F, #4B639D, #5A8863, #DE7970, #FDF9CC) calc(44.3% - 2px), #000 calc(44.3% - 1.5px), #000 calc(44.3% + 2px), transparent calc(44.3% + 2.5px)),\n      radial-gradient(circle at 100% @p(0, 100%), @p(#689FC0, #CF6756, #543235, #F6C7C8, #ECBB3F, #4B639D, #5A8863, #DE7970, #FDF9CC) calc(35.36% - 2px), #000 calc(35.36% - 1.5px), #000 calc(35.36% + 2px), transparent calc(35.36% + 2.5px)),\n      linear-gradient(@p(#689FC0, #CF6756, #543235, #F6C7C8, #ECBB3F, #4B639D, #5A8863, #DE7970, #FDF9CC), @lp);\n  }\n  @random(0.2) {\n    --color: @p(#689FC0, #CF6756, #543235, #F6C7C8, #ECBB3F, #4B639D, #5A8863, #DE7970, #FDF9CC);\n    background:\n      @m(2, (linear-gradient(@pn(180, 90)deg, @pn(transparent, var(--color)) calc(100% - 4px), #000 calc(100% - 4px)) no-repeat 0 0 / calc(50% + 2px) calc(50% + 2px))),\n      @p(radial-gradient(circle at 0 0, @p(#689FC0, #CF6756, #543235, #F6C7C8, #ECBB3F, #4B639D, #5A8863, #DE7970, #FDF9CC) calc(35.36% - 2px), #000 calc(35.36% - 1.5px), #000 calc(35.36% + 2px), transparent calc(35.36% + 2.5px)), linear-gradient(@m2(transparent))),\n      linear-gradient(@p(#689FC0, #CF6756, #543235, #F6C7C8, #ECBB3F, #4B639D, #5A8863, #DE7970, #FDF9CC), @lp);\n  }\n);\n              "
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            id: "card-content",
                            className: feature ? " py-2 h-20 rounded-b-md px-2 font-bold text-dark1 bg-[#292939]/70" : " my-2 rounded-md px-2  text-dark1",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex h-full flex-col justify-between",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex flex-col",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "font-bold ".concat(feature ? "text-white" : "text-dark1"),
                                                children: name
                                            }),
                                            !feature && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: " mb-1 flex flex-row justify-between",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "text-sm text-dark1 opacity-50",
                                                    children: "Form"
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex flex-col ".concat(feature ? "hidden" : ""),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: " flex flex-row justify-between",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "text-sm text-dark1 opacity-50",
                                                        style: {
                                                            display: feature ? "none" : ""
                                                        },
                                                        children: "Views"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "text-sm text-dark1 opacity-50",
                                                        style: {
                                                            display: feature ? "none" : ""
                                                        },
                                                        children: "Reward"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "flex flex-row justify-between",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "text-sm text-dark1",
                                                        children: campaign.pageView
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "text-sm text-dark1",
                                                        children: reward === null || reward === void 0 ? void 0 : reward.toUpperCase()
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    feature && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex flex-row text-white text-xs",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                children: "Views:\xa0"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                children: campaign.pageView
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "text-secondary flex items-center justify-center rounded-b-md bg-primary text-white py-1 ".concat(feature ? "hidden" : ""),
                    children: "Visit"
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./src/hooks/useRequest.tsx
var useRequest = __webpack_require__(21706);
;// CONCATENATED MODULE: ./src/airdrop/components/AllAirdropsGrid.js













function AllAirdropsGrid(param) {
    var pageNum = param.pageNum, type = param.type;
    var router = (0,next_router.useRouter)();
    var filterItems = [
        "NFT",
        "TOKEN",
        "Form"
    ];
    var ref = (0,react.useState)(type === "ALL" ? "ALL" : type), buttonSelect = ref[0], setButtonSelect = ref[1];
    var ref1 = (0,useRequest/* default */.Z)({
        function: "campaign/get_featured_campaigns",
        data: {}
    }), featuredCampaigns = ref1.data, featuredCampaignsLoading = ref1.isLoading;
    var ref2 = (0,useRequest/* default */.Z)({
        function: "campaign/get_all_campaigns",
        data: {}
    }), allCampaigns = ref2.data, allCampaignsLoading = ref2.isLoading;
    var campaignLoading = featuredCampaignsLoading || allCampaignsLoading;
    var campaigns = allCampaigns || [];
    var recentCampaigns = campaigns.slice(0, 12);
    var featuresCampaigns = featuredCampaigns || [];
    var ALLCampaigns = campaigns;
    var NFTCampaigns = campaigns === null || campaigns === void 0 ? void 0 : campaigns.filter(function(campaign) {
        return campaign.type === "NFT";
    });
    var TokenCampaigns = campaigns === null || campaigns === void 0 ? void 0 : campaigns.filter(function(campaign) {
        return campaign.type === "TOKEN";
    });
    var FormCampaigns = campaigns === null || campaigns === void 0 ? void 0 : campaigns.filter(function(campaign) {
        return campaign.type === "FORM";
    });
    var nftRef = (0,react.useRef)(null);
    var ref3 = (0,react.useState)(Number(pageNum)), activePage = ref3[0], setActivePage = ref3[1];
    var ref4 = (0,react.useState)(0), pageCountAll = ref4[0], setPageCountAll = ref4[1];
    var ref5 = (0,react.useState)(0), pageCount = ref5[0], setPageCount = ref5[1];
    var ref6 = (0,react.useState)(0), pageCountToken = ref6[0], setPageCountToken = ref6[1];
    var setSearchParams = (0,react.useCallback)(function(query) {
        var changed = false;
        for(var prop in query){
            if (String(query[prop]) !== String(router.query[prop])) {
                changed = true;
                break;
            }
        }
        if (changed) {
            router.push({
                pathname: router.pathname,
                query: query
            }, undefined, {
                scroll: false
            });
        }
    }, [
        router
    ]);
    var onChangePage = (0,react.useCallback)(function(page) {
        setSearchParams({
            page: page,
            type: type
        });
    }, [
        setSearchParams,
        type
    ]);
    var itemsPerPage = 10;
    var itemsVisited = (activePage - 1) * itemsPerPage;
    var ref7;
    var ALLdisplay = (ref7 = ALLCampaigns === null || ALLCampaigns === void 0 ? void 0 : ALLCampaigns.map(function(item, index) {
        if (item.type === "FORM") {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(CampaignGridItem, {
                campaign: item
            }, index);
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(AirdropGridItem, {
            campaign: item,
            feature: false
        }, index);
    })) !== null && ref7 !== void 0 ? ref7 : [];
    var ref8;
    var NFTdisplay = (ref8 = NFTCampaigns === null || NFTCampaigns === void 0 ? void 0 : NFTCampaigns.map(function(item, index) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(AirdropGridItem, {
            campaign: item,
            feature: false
        }, index);
    })) !== null && ref8 !== void 0 ? ref8 : [];
    var TOKENdisplay = TokenCampaigns === null || TokenCampaigns === void 0 ? void 0 : TokenCampaigns.map(function(item, index) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(AirdropGridItem, {
            campaign: item,
            feature: false
        }, index);
    });
    var FormDisplay = FormCampaigns === null || FormCampaigns === void 0 ? void 0 : FormCampaigns.map(function(item, index) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(CampaignGridItem, {
            campaign: item
        }, index);
    });
    // console.log(featuresCampaigns);
    var FeaturesDisplay = featuresCampaigns === null || featuresCampaigns === void 0 ? void 0 : featuresCampaigns.map(function(item, index) {
        if (item.type === "FORM") {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(CampaignGridItem, {
                campaign: item,
                feature: true
            }, index);
        } else {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(AirdropGridItem, {
                campaign: item,
                feature: true
            }, index);
        }
    });
    (0,react.useEffect)(function() {
        // setDisplayCampaign(type === 'NFT' ? NFTdisplay : TOKENdisplay);
        // console.log(NFTdisplay, TOKENdisplay);
        setPageCountAll(Math.ceil(ALLCampaigns.length / itemsPerPage));
        setPageCount(Math.ceil(NFTCampaigns.length / itemsPerPage));
        setPageCountToken(Math.ceil(TokenCampaigns.length / itemsPerPage));
    // eslint-disable-next-line
    }, [
        ALLCampaigns,
        NFTCampaigns,
        TokenCampaigns
    ]);
    var displayCampaign = (type === "ALL" ? ALLdisplay : type === "NFT" ? NFTdisplay : type === "TOKEN" ? TOKENdisplay : FormDisplay).slice(itemsVisited, itemsVisited + itemsPerPage);
    (0,react.useEffect)(function() {
        nftRef.current.scrollIntoView({
            behavior: "smooth"
        });
    }, [
        activePage
    ]);
    // useEffect(() => {
    //   setDisplayCampaign(type === 'NFT' ? NFTdisplay : TOKENdisplay);
    //   //eslint-disable-next-line
    // }, []);
    (0,react.useEffect)(function() {
        setButtonSelect(type);
        setActivePage(Number(pageNum));
    }, [
        type,
        pageNum
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                className: "mx-auto mb-8 flex flex-row text-4xl font-bold sm:mb-14",
                children: "Featured airdrops"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex justify-center sm:hidden",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(homepage_CampaignsCarouselMobile, {
                    recentCampaigns: recentCampaigns,
                    campaignLoading: campaignLoading,
                    feature: true
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mb-[66px] hidden flex-col justify-between sm:flex",
                children: campaignLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex justify-center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Loader/* Loader */.a, {
                        color: "#ADB5FF"
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "grid grid-cols-1 gap-3 md:grid-cols-4 lg:grid-cols-4",
                    children: FeaturesDisplay
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex h-6 flex-row justify-between",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                        ref: nftRef,
                        className: " flex flex-row text-body sm:text-lg font-bold ",
                        children: "All Campaigns"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: " text-md flex flex-row items-center justify-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mr-4 flex flex-row",
                                children: " Filter "
                            }),
                            filterItems.map(function(item, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    className: buttonSelect === item ? "btn-pri-base mr-2  px-2 py-1 text-white" : "btn-sec-base mr-2  px-2 py-1 text-dark1",
                                    onClick: function() {
                                        if (item === type) {
                                            setSearchParams({
                                                type: "ALL",
                                                page: 1
                                            });
                                        } else {
                                            setSearchParams({
                                                type: item,
                                                page: 1
                                            });
                                        }
                                    },
                                    children: item
                                }, index);
                            })
                        ]
                    })
                ]
            }),
            campaignLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mt-6 flex justify-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Loader/* Loader */.a, {
                    color: "#ADB5FF"
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mt-6",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "grid grid-cols-2 gap-3 md:grid-cols-3 lg:grid-cols-5",
                        children: displayCampaign
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Pagination/* Pagination */.t, {
                        className: "flex justify-center py-10 ",
                        styles: {
                            active: {
                                color: "#adb5ff",
                                border: "none",
                                backgroundColor: "transparent"
                            }
                        },
                        value: activePage,
                        onChange: onChangePage,
                        total: type === "NFT" ? pageCount : type === "ALL" ? pageCountAll : pageCountToken
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 54167:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components_common_Nav__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27356);
/* harmony import */ var react_div_100vh__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(66409);







var Container = function(_param) {
    var children = _param.children, id = _param.id, showConnect = _param.showConnect, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "children",
        "id",
        "showConnect"
    ]);
    var height = (0,react_div_100vh__WEBPACK_IMPORTED_MODULE_3__/* .use100vh */ .g)();
    var connectShow = typeof showConnect === "undefined" ? true : showConnect;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, props), {
        className: "layout-content",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_common_Nav__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                showConnect: connectShow
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                style: {
                    height: height ? "".concat(height - 60, "px") : "calc(100vh-60px)"
                },
                id: id,
                className: "overflow-y-scroll overflow-x-hidden",
                children: children
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Container);


/***/ }),

/***/ 70611:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ useQuery; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);


var useQuery = function() {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    return new URLSearchParams(router.query);
};


/***/ })

}]);